import React, { useState } from "react";

const DropAreaInformation = ({
  index,
  informations,
  setInformations,
  activeInformation,
}) => {
  const [showDropArea, setShowDropArea] = useState(false);
  const onDrop = (e) => {
    e.preventDefault();
    let listTemp = [...informations];
    let dataToMoved = listTemp[activeInformation];
    if (activeInformation > index) {
      listTemp = listTemp.filter((info, ind) => ind !== activeInformation);
      listTemp.splice(index, 0, dataToMoved);
    } else {
      listTemp.splice(index, 0, dataToMoved);
      listTemp = listTemp.filter((info, ind) => ind !== activeInformation);
    }
    setInformations([...listTemp]);
  };
  return (
    <div
      onDragEnter={() => setShowDropArea(true)}
      onDragLeave={() => setShowDropArea(false)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        onDrop(e);
        setShowDropArea(false);
      }}
      className={`flex flex-col ${
        showDropArea ? "h-10 transition-all ease-in-out" : "h-0 opacity-0"
      } w-full border-gray-500 border-dashed border-2 rounded-lg text-center justify-center bg-gray-50`}
    >
      Drop here
    </div>
  );
};

export default DropAreaInformation;
